import { useContext } from 'react';

import { CallbackActionType, ConfigDialogType, ConfirmDialogContext } from 'context/ConfirmDialogProvider';

export const useConfirmDialog = () => {
  const { openDialog } = useContext(ConfirmDialogContext);

  const getConfirmation = ({ ...options }: Partial<ConfigDialogType>) =>
    new Promise((res: CallbackActionType) => {
      if (typeof openDialog !== 'function') return;

      openDialog({
        actionCallback: res,
        title: options.title || '',
        message: options.message || '',
        textConfirmButton: options.textConfirmButton || '',
        textDismissButton: options.textDismissButton || '',
      });
    });

  return { getConfirmation };
};
